/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module block-quote
 */

export { default as BlockQuote } from './blockquote';
export { default as BlockQuoteEditing } from './blockquoteediting';
export { default as BlockQuoteUI } from './blockquoteui';
